<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title border-0 pb-0" >درخواست های بازگشت دستگاه های ثبت شده کاربران</h5>


    <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1"> نام کارشناس </label>
        <input [(ngModel)]="Filter_Expert" (keyup)="Change_Filter()" name="Filter_Expert" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1"> کد دستگاه </label>
        <input [(ngModel)]="Filter_DeviceCode" (keyup)="Change_Filter()" name="Filter_DeviceCode" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1"> سریال دستگاه </label>
        <input [(ngModel)]="Filter_DeviceSerial" (keyup)="Change_Filter()" name="Filter_DeviceSerial" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1"> شماره رسید </label>
        <input [(ngModel)]="Filter_Code" (keyup)="Change_Filter()" name="Filter_Code" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>

    <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!InProccessing" type="button" (click)="ReadData_Lab()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

    <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>دستگاه (کد/سریال)</th>
              <th>نام مشتری</th>
              <th>شماره رسید</th>
              <th>تاریخ دریافت</th>
              <th>شرح دریافت</th>
              <th>تاریخ ورود</th>
              <th>نام کارشناس</th>
              <th>شرح درخواست</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Lab
            |filter:Filter_Expert:'labAdderss'
            |filter:Filter_DeviceCode:'device_code'
            |filter:Filter_DeviceSerial:'device_serial'
            |filter:Filter_Code:'kala_code'
            | paginate
                    : {
                        id: 'DataList_UserTable_Pay',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Lab
                        |filter:Filter_Expert:'labAdderss'
                        |filter:Filter_DeviceCode:'device_code'
                        |filter:Filter_DeviceSerial:'device_serial'
                        |filter:Filter_Code:'kala_code'
                        ).length
                      }
            ">
             <td>
                <p *ngIf="item.visible">{{DataList_Lab.indexOf(item)+1}}</p>
                <span *ngIf="!item.visible" class="badge badge-pill badge-info float-right mt-1">جدید</span>
             </td>
             <td>
              {{item.device_name}}
              <p> ({{item.device_code}} / {{item.device_serial}}) </p>
             </td>
             <td>{{item.expiration_title}}</td>
             <td>{{item.kala_code}}</td>
             <td>{{item.tEMPERATURE_Vahed_Title}}</td>
             <td>{{item.priority_title}}</td>
             <td>{{item.persianDate}}</td>
             <td>{{item.labAdderss}}</td>
             <td>{{item.dsc}}</td>
             <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,1)"><i class="fa fa-check"></i> تایید </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,-1)"><i class="fa fa fa-times-rectangle"></i> عدم تایید </a>
                    </div>
                </div>

            </div>
            </td>
            </tr>
          </tbody>
        </table>
    </div>

    <pagination-controls
    id="DataList_UserTable_Pay"
    nextLabel="بعدی"
    previousLabel="قبلی"
    (pageChange)="page = $event"
  ></pagination-controls>

  </div>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete_Status==-1" class="modal-title pull-left"> عدم تایید بازگشت دستگاه '{{Data_Seleted_Delete.device_name}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete_Status==1" class="modal-title pull-left">  تایید بازگشت دستگاه '{{Data_Seleted_Delete.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="OperationDsc"  name="OperationDsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete_Status==-1" type="button" class="btn btn-danger" (click)="AnswerReview()"> عدم تایید <i class="fa fa-times-rectangle"></i></button>
    <button *ngIf="Data_Seleted_Delete_Status==1" type="button" class="btn btn-success" (click)="AnswerReview()"> تایید <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>
